if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        // for-ordained-members-only
        const isCustomer = this.form.querySelector('.isCustomerOrdained');
        const isOrdained = this.form.querySelector('.isOrdainedOrdained');
        if(isCustomer && isCustomer.value == 'false' && isOrdained && isOrdained.value == 'false'){
          this.handleErrorMessage('You must be logged-in to add this item to your cart. & You must be an ordained minister to add this item to your cart');
          return;
        }

        if(isCustomer && isCustomer.value == 'false'){
           this.handleErrorMessage('You must be logged-in to add this item to your cart.');
            return;
        }

       if(isOrdained && isOrdained.value == 'false'){
           this.handleErrorMessage('You must be an ordained minister to add this item to your cart');
            return;
        }

        // for-members
         const isCustomerMember = this.form.querySelector('.isCustomerMember');
        if(isCustomerMember && isCustomerMember.value == 'false'){
           this.handleErrorMessage('You must be logged-in to add this item to your cart.');
            return;
        }

        this.handleErrorMessage();

         const extraChecked = this.form.querySelector('input[name="extra_option"]:checked');
          if (extraChecked && !extraChecked) {
            this.handleErrorMessage("Please select Yes or No first.");
            return;
          }

          if (extraChecked && extraChecked.value === 'yes') {
            const bothCheck = this.form.querySelector('input[name="extra_variant"]:checked');

            if (!bothCheck) {
              this.handleErrorMessage("Please select a donate price.");
              return;
            }
          }
        

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // const selectedOptAddon = this.querySelector('input[name="extra_variant"]:checked');
        // if (
        //   extraChecked &&
        //   extraChecked.value === 'yes' &&
        //   selectedOptAddon &&
        //   selectedOptAddon.value !== ''
        // ) {
        //   const addonGroupId = Math.floor(Math.random() * 1000000000);
        //   formData.append('properties[addon]', addonGroupId);
        //   formData.append('items[1][id]', selectedOptAddon.value);
        //   formData.append('items[1][properties[addon]]', addonGroupId);
        //   formData.append('items[1][properties[isaddon]]', 'true');
        // }

        // ordained
        const checkedAddons = document.querySelectorAll('.addon-checkbox:checked');
        if(checkedAddons){
            const addonGroupNo = Math.floor(Math.random() * 1000000000);
            checkedAddons.forEach((el, index) => {
            formData.append('properties[_addon]', addonGroupNo);
            formData.append(`items[${index}][id]`, el.dataset.id);
            formData.append(`items[${index}][properties[_addon]]`, addonGroupNo);
            formData.append(`items[${index}][properties[_isaddon]]`, 'true');
          });
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// custom

document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('input[name="extra_option"]');
  const variantBox = document.getElementById("extra-variants");

  const checked = document.querySelector('input[name="extra_option"]:checked');
  if (checked && checked.value === "yes") {
    variantBox.style.display = "block";
  }

  radios.forEach(radio => {
    radio.addEventListener("change", function () {
      if (this.value === "yes") {
        variantBox.style.display = "block";
      } else {
        variantBox.style.display = "none";
      }
    });
  });
});

